<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";

  export let index: number;

  $: xVal = $LayoutStore.isMobile ? 0 : 20;

</script>

<div class="fizz-stack-16" class:fizz-border-top={index > 0} />
<div class="fizz-flex-row fizz-space-between fizz-stack-16">
  <div class="fizz-flex-vertical">
    <Skeleton animate={true} height={70} width={200}>
      <rect width="100" height="15" x={xVal} y="10" rx="12" ry="12" />
      <rect width="130" height="15" x={xVal} y="30" rx="12" ry="12" />
    </Skeleton>
  </div>

  <div class="fizz-flex-vertical fizz-inset-horizontal-16">
    <Skeleton animate={true} height={70} width={120}>
      <rect width="100" height="15" x={xVal} y="30" rx="12" ry="12" />
    </Skeleton>
  </div>
</div>
